function CtaSection() {
  return (
    <section id="precios" className="cta" aria-labelledby="cta-title">
      <div className="cta__inner">
        <h2 id="cta-title" className="cta__title">
          Empieza a llevar control de tus trades hoy
        </h2>
        <p className="cta__subtitle">
          Únete a traders que documentan cada operación en la bolsa de EE.UU. y mejoran con
          datos reales.
        </p>
        <a href="https://app.ebitrade.com/register" className="btn btn--primary btn--lg">
          Crear cuenta en ebitrade.com
        </a>
      </div>
    </section>
  );
}

export default CtaSection;
